export default {
    props: {
      oneAtATime: {
        type: Boolean,
        default: false
      }
    },
    created() {
      this.$on('isOpenEvent', (child)=> {
        if (this.oneAtATime) {
          this.$children.forEach((item) => {
            if (child !== item ) {
              item.isOpen = false
            }
          })
        }
      })
    }
  }


/** WEBPACK FOOTER **
 ** ./~/vue-loader/lib/selector.js?type=script&index=0!./src/Accordion.vue
 **/